// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as SupItems from "./SupItems.bs.js";
import * as SupUnits from "./SupUnits.bs.js";
import * as SupTraits from "./SupTraits.bs.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as SupAugments from "./SupAugments.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as SupTacticians from "./SupTacticians.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as SupStarterPack from "./SupStarterPack.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

function navTabLabel(v) {
  switch (v) {
    case /* General */0 :
        return "gameplay";
    case /* Units */1 :
        return "units";
    case /* Traits */2 :
        return "traits";
    case /* Items */3 :
        return "items";
    case /* Augments */4 :
        return "augments";
    case /* Tacticians */5 :
        return "tacticians";
    case /* Charms */6 :
        return "charms";
    
  }
}

var topStates = {
  contents: {
    units: 9999,
    traits: 9999,
    items: 9999,
    augments: 9999,
    tacticians: 9999
  }
};

function getTop(id) {
  return Belt_Option.getExn(Caml_option.nullable_to_opt(document.getElementById(id))).getBoundingClientRect().top;
}

function recalcTopStates(param) {
  var pageY = window.pageYOffset;
  var unitsTop = getTop("set-update-units");
  var traitsTop = getTop("set-update-traits");
  var itemsTop = getTop("set-update-items");
  var augmentsTop = getTop("set-update-augments");
  var tacticiansTop = getTop("set-update-tacticians");
  topStates.contents = {
    units: pageY + unitsTop,
    traits: pageY + traitsTop,
    items: pageY + itemsTop,
    augments: pageY + augmentsTop,
    tacticians: pageY + tacticiansTop
  };
  
}

function Set9UpdatePage$Inner(Props) {
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return /* General */0;
      });
  var setTab = match[1];
  var screenSize = ScreenAtom.use(undefined);
  React.useEffect((function () {
          recalcTopStates(undefined);
          document.addEventListener("scroll", (function (e) {
                  var y = window.scrollY;
                  var topStates$1 = topStates.contents;
                  if (y > topStates$1.tacticians - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Tacticians */5;
                                }));
                  } else if (y > topStates$1.augments - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Augments */4;
                                }));
                  } else if (y > topStates$1.items - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Items */3;
                                }));
                  } else if (y > topStates$1.traits - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Traits */2;
                                }));
                  } else if (y > topStates$1.units - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Units */1;
                                }));
                  } else {
                    return Curry._1(setTab, (function (param) {
                                  return /* General */0;
                                }));
                  }
                }), {
                capture: false,
                once: false,
                passive: true
              });
          
        }), []);
  return React.createElement("div", {
              className: "flex flex-col items-center"
            }, React.createElement("div", {
                  className: "flex flex-col items-center w-[375px] sm:w-[650px] md:w-[970px]"
                }, React.createElement("div", {
                      className: "relative mt-8 w-[320px] sm:w-[640px] md:w-[960px] h-[320px] sm:h-[640px] md:h-[960px]"
                    }, React.createElement("img", {
                          className: "rounded",
                          height: "960",
                          src: "https://ap.tft.tools/img/cd14/keyart.jpg?w=960",
                          width: "960"
                        }), React.createElement("img", {
                          className: "rounded absolute left-[50px] sm:left-[100px] md:left-[150px] bottom-[-16px] sm:bottom-[-32px] md:bottom-[-48px] w-[220px] sm:w-[440px] md:w-[660px]",
                          src: "https://ap.tft.tools/img/cd14/logo.jpg?w=660",
                          width: "660"
                        })), React.createElement(ContentSection.make, {
                      id: "set-update-gameplay",
                      className: "mt-8 leading-tight grid grid-cols-1 md:grid-cols-2 gap-8 md:w-[960px]",
                      children: null
                    }, React.createElement("div", undefined, React.createElement("h2", {
                              className: "h2 pb-2"
                            }, "Set Mechanic: Hacks"), React.createElement("div", {
                              className: "leading-snug"
                            }, "In Cyber City, you will ", React.createElement("i", undefined, "encounter"), " hacks that steer your game in unexpected directions! Unstable components morph every round if left on your bench, neutral monsters might drop health points, and hacked augment rounds could let you pick 2 augments instead of 1. Plus, augments once banished from The Convergence have been spotted on The Black Market—and thanks to a few surprise exploits, they might just pop up in your games. Get ready to Think Fast!")), React.createElement("iframe", {
                          width: screenSize === /* Xs */5 ? "320" : "448",
                          height: screenSize === /* Xs */5 ? "180" : "252",
                          src: "https://www.youtube.com/embed/9Ya0bURN_Zc?si=4vBnImL05-_NQyah",
                          title: "Cyber City",
                          frameborder: "0",
                          allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                          allowfullscreen: true
                        })), React.createElement("div", {
                      className: "p-6 py-5 bg-secondary-4 border border-secondary-11 mt-8 leading-tight rounded"
                    }, React.createElement("div", undefined, "Cyber City will be available on PBE March 18th afternoon PT."), React.createElement("div", {
                          className: "mt-1"
                        }, "It will launch on live servers Wednesday, April 2nd with patch 14.1.")), React.createElement(SupStarterPack.make, {}), React.createElement("div", {
                      className: "sticky mt-8 z-10 top-[47px] w-full sm:w-[650px] md:w-[970px]"
                    }, React.createElement("div", {
                          className: "bg-bg0"
                        }, React.createElement(Tabs, {
                              variant: "scrollable",
                              children: null,
                              value: match[0],
                              onChange: (function (param, t) {
                                  Curry._1(setTab, (function (param) {
                                          return t;
                                        }));
                                  recalcTopStates(undefined);
                                  var top = Belt_Option.getExn(Caml_option.nullable_to_opt(document.getElementById("set-update-" + navTabLabel(t)))).getBoundingClientRect().top + window.pageYOffset - 140;
                                  window.scrollTo({
                                        behavior: "smooth",
                                        left: 0,
                                        top: top
                                      });
                                  
                                })
                            }, React.createElement(Tab, {
                                  label: t("Gameplay"),
                                  value: /* General */0
                                }), React.createElement(Tab, {
                                  label: t("Units"),
                                  value: /* Units */1
                                }), React.createElement(Tab, {
                                  label: t("Traits"),
                                  value: /* Traits */2
                                }), React.createElement(Tab, {
                                  label: t("Items"),
                                  value: /* Items */3
                                }), React.createElement(Tab, {
                                  label: t("Augments"),
                                  value: /* Augments */4
                                }), React.createElement(Tab, {
                                  label: t("Cosmetics"),
                                  value: /* Tacticians */5
                                })))), React.createElement(SupUnits.make, {}), React.createElement(SupTraits.make, {}), React.createElement(SupItems.make, {}), React.createElement(SupAugments.make, {}), React.createElement(SupTacticians.make, {})));
}

var Inner = {
  make: Set9UpdatePage$Inner
};

function Set9UpdatePage(Props) {
  var anomalies = Props.anomalies;
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set14 */6, React.createElement(Set9UpdatePage$Inner, {
                      anomalies: anomalies
                    }), undefined));
}

var make = Set9UpdatePage;

export {
  navTabLabel ,
  topStates ,
  getTop ,
  recalcTopStates ,
  Inner ,
  make ,
  
}
/* react Not a pure module */
